import { all, put, fork, takeEvery, select, delay } from 'redux-saga/effects';
import actions from './actions';
import dashboardActions from '../dashboard/actions';
import { get, post, DELETE, PUT } from '@iso/lib/helpers/resApiRequestor';
import { filterDuplicateData } from '@iso/lib/helpers/utility';
import { LOOKUPS, DATEFORMATTER } from '@iso/containers/constants';
import { isoDateFormatter } from '@iso/lib/helpers/stringUtils';
import merchantAction from '../merchant/actions'

export function* fetchAllAccountOfficers() {
  yield takeEvery('FETCH_ACCOUNT_OFFICER_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_ACCOUNT_OFFICER_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchAllAccountOfficerAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ACCOUNT_OFFICER_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_ACCOUNT_OFFICER_DATA_FAILED,
          result: [],
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ACCOUNT_OFFICER_DATA_FAILED,
        loading: false,
        result: []
      });
    }
  });
}

export function* fetchMerchantStatusCount() {
  yield takeEvery('FETCH_MERCHANT_STATUS_COUNT_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_STATUS_COUNT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchMerchantStatusCountAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_STATUS_COUNT_DATA_SUCCESS,
          loading: false,
          filter: payload,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_STATUS_COUNT_DATA_FAILED,
          result: [],
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_STATUS_COUNT_DATA_FAILED,
        loading: false,
        result: []
      });
    }
  });
}
export function* fetchAllAccountOfficerTeam() {
  yield takeEvery('FETCH_ACCOUNT_OFFICER_TEAM_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_ACCOUNT_OFFICER_TEAM_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchAllAccountOfficerTeamAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ACCOUNT_OFFICER_TEAM_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_ACCOUNT_OFFICER_TEAM_DATA_FAILED,
          loading: false
          // result: []
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ACCOUNT_OFFICER_TEAM_DATA_FAILED,
        loading: false
        // result: []
      });
    }
  });
}
export function* addAccountOfficerData() {
  yield takeEvery('ADD_ACCOUNT_OFFICER_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_ACCOUNT_OFFICER_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addAccountOfficerDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_ACCOUNT_OFFICER_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ACCOUNT_OFFICER_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_ACCOUNT_OFFICER_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_ACCOUNT_OFFICER_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_ACCOUNT_OFFICER_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addAccountOfficerDataTeam() {
  yield takeEvery('ADD_NEW_ACCOUNT_OFFICER_TEAM_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_NEW_ACCOUNT_OFFICER_TEAM_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addAccountOfficerTeamAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_NEW_ACCOUNT_OFFICER_TEAM_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ACCOUNT_OFFICER_TEAM_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_NEW_ACCOUNT_OFFICER_TEAM_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_NEW_ACCOUNT_OFFICER_TEAM_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_NEW_ACCOUNT_OFFICER_TEAM_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editAccountOfficerData() {
  yield takeEvery('EDIT_ACCOUNT_OFFICER_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_ACCOUNT_OFFICER_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editAccountOfficerDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_ACCOUNT_OFFICER_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ACCOUNT_OFFICER_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_ACCOUNT_OFFICER_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_ACCOUNT_OFFICER_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_ACCOUNT_OFFICER_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editAccountOfficerTeam() {
  yield takeEvery('EDIT_ACCOUNT_OFFICER_TEAM_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_ACCOUNT_OFFICER_TEAM_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editAccountOfficerDataTeamAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FETCH_ACCOUNT_OFFICER_TEAM_DATA
        });
        yield put({
          type: actions.EDIT_ACCOUNT_OFFICER_TEAM_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        // yield put({
        //   type: actions.FETCH_ACCOUNT_OFFICER_DATA
        // });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_ACCOUNT_OFFICER_TEAM_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_ACCOUNT_OFFICER_TEAM_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_ACCOUNT_OFFICER_TEAM_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* updateAccountOfficerStatus() {
  yield takeEvery('UPDATE_ACCOUNT_OFFICER_STATUS', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_ACCOUNT_OFFICER_STATUS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateAccountOfficerStatusAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_ACCOUNT_OFFICER_STATUS_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ACCOUNT_OFFICER_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_ACCOUNT_OFFICER_STATUS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_ACCOUNT_OFFICER_STATUS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_ACCOUNT_OFFICER_STATUS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* deleteAccountOfficerData() {
  yield takeEvery('DELETE_ACCOUNT_OFFICER_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.DELETING_ACCOUNT_OFFICER_DATA,
        loading: true,
        isError: false
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield deleteAccountOfficerDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DELETE_ACCOUNT_OFFICER_DATA_SUCCESS,
          loading: false,
          message: result.message,
          isError: false
        });
        yield put({
          type: actions.FETCH_ACCOUNT_OFFICER_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DELETE_ACCOUNT_OFFICER_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            isError: true
          });
        } else {
          yield put({
            type: actions.DELETE_ACCOUNT_OFFICER_DATA_FAILED,
            message: result.message,
            loading: false,
            isError: true
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_ACCOUNT_OFFICER_DATA_FAILED,
        message: 'Failed to process request',
        loading: false,
        isError: true
      });
    }
  });
}
export function* deleteAccountOfficerOnTeam() {
  yield takeEvery('DELETE_ACCOUNT_OFFICER_ON_TEAM_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.DELETING_ACCOUNT_OFFICER_ON_TEAM_DATA,
        loading: true,
        isError: false
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield deleteAccountOfficerOnTeamAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DELETE_ACCOUNT_OFFICER_ON_TEAM_DATA_SUCCESS,
          loading: false,
          message: result.message,
          isError: false
        });
        yield put({
          type: actions.FETCH_ACCOUNT_OFFICER_TEAM_DATA
        });
        yield put({
          type: actions.FETCH_ACCOUNT_OFFICER_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DELETE_ACCOUNT_OFFICER_ON_TEAM_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            isError: true
          });
        } else {
          yield put({
            type: actions.DELETE_ACCOUNT_OFFICER_ON_TEAM_DATA_FAILED,
            message: result.message,
            loading: false,
            isError: true
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_ACCOUNT_OFFICER_ON_TEAM_DATA_FAILED,
        message: 'Failed to process request',
        loading: false,
        isError: true
      });
    }
  });
}
export function* fetchAllLeadManagementDataList() {
  yield takeEvery('FETCH_LEAD_MANAGEMENT_LIST_DATA', function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_LEAD_MANAGEMENT_LIST_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchAllLeadManagementListAPI(payload, pagination, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_LIST_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null,
          filter: payload ? payload : null,
          pagination: result ? result.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_LIST_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LEAD_MANAGEMENT_LIST_DATA_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchAllLeadManagementDataListByMQTT() {
  yield takeEvery('FETCH_LEAD_MANAGEMENT_LIST_DATA_BY_MQTT', function* ({ payload }) {
    try {
      const roleHeaderAuth = yield getRoleHeader();

      const state = yield select();

      const leadManagementListData = state.AccountOfficer.leadManagementListData;
      const listPagination = state.AccountOfficer.listPagination;
      const listFilter = state.AccountOfficer.listFilter;

      const apiResult = yield fetchAllLeadManagementListAPI(
        listPagination,
        listFilter,
        roleHeaderAuth
      );

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_LIST_DATA_SUCCESS_BY_MQTT,
          result: result ? result.data : null,
          filter: listFilter ? listFilter : null,
          pagination: listPagination ? listPagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_LIST_DATA_FAILED_BY_MQTT,
          loading: false,
          payload: leadManagementListData ? leadManagementListData : []
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LEAD_MANAGEMENT_LIST_DATA_FAILED_BY_MQTT,
        loading: false,
        payload: []
      });
    }
  });
}

export function* fetchFilteredMerchantDataList() {
  yield takeEvery('FETCH_FILTERED_LEAD_MANAGEMENT_LIST_DATA', function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_FILTERED_LEAD_MANAGEMENT_LIST_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchFilteredLeadMerchantAPI(payload, pagination, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FETCH_FILTERED_LEAD_MANAGEMENT_LIST_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null,
          filter: payload,
          pagination: result ? result.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_FILTERED_LEAD_MANAGEMENT_LIST_DATA_FAILED,
          result: result ? result.data : null,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_FILTERED_LEAD_MANAGEMENT_LIST_DATA_FAILED,
        result: null,
        loading: false
      });
    }
  });
}

export function* fetchAllLeadManagementDataCalendar() {
  yield takeEvery('FETCH_LEAD_MANAGEMENT_CALENDAR_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_LEAD_MANAGEMENT_CALENDAR_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchAllLeadManagementCalendarAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_CALENDAR_DATA_SUCCESS,
          loading: false,
          filter: payload,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_CALENDAR_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LEAD_MANAGEMENT_CALENDAR_DATA_FAILED,
        loading: false
      });
    }
  });
}
export function* fetchAllLeadManagementDataReport() {
  yield takeEvery('FETCH_LEAD_MANAGEMENT_REPORT_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_LEAD_MANAGEMENT_REPORT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchAllLeadManagementReportAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_REPORT_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_REPORT_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LEAD_MANAGEMENT_REPORT_DATA_FAILED,
        loading: false
      });
    }
  });
}
export function* editLeadMerchantListStatusData() {
  yield takeEvery('UPDATE_LEAD_MERCHANT_LIST_DATA', function* ({ payload, id, currentFilter }) {
    try {
      yield put({
        type: actions.UPDATING_LEAD_MERCHANT_LIST_DATA,
        loading: true
      });
      const state = yield select();
      const currentPagination = state.AccountOfficer.listPagination;
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateLeadMerchantStatusListDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success && currentPagination) {
        yield put({
          type: actions.UPDATE_LEAD_MERCHANT_LIST_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_LIST_DATA,
          payload: currentFilter,
          pagination: {
            page: currentPagination.current_page,
            limit: currentPagination.page_size
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_LEAD_MERCHANT_LIST_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_LEAD_MERCHANT_LIST_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_LEAD_MERCHANT_LIST_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addLeads() {
  yield takeEvery('ADD_LEADS', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_LEADS,
        loading: true
      });

      const leadType = payload.lead_type;
      const state = yield select();
      const currentFilter = state.AccountOfficer.leadsMgmtFilter;
      const roleHeaderAuth = yield getRoleHeader();

      let apiResult = '';
      if (leadType === LOOKUPS.HUNTING_LEAD) {
        apiResult = yield addHuntingLeadAPI(payload, roleHeaderAuth);
      } else {
        apiResult = yield addHuntingLeadAPI(payload, roleHeaderAuth);
      }

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_LEADS_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_LEADS,
          payload: currentFilter,
          pagination: { page: 0, limit: 20, loadMore: false }
        });

        if (result.data && result.data.id) {
          yield put({
            type: actions.FETCH_LEADS_BY_ID,
            id: result.data.id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_LEADS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_LEADS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_LEADS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addLeadsByRM() {
  yield takeEvery('ADD_LEADS_BY_RM', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_LEADS_BY_RM,
        loading: true
      });

      const state = yield select();
      const currentFilter = state.AccountOfficer.leadsMgmtFilter;
      const roleHeaderAuth = yield getRoleHeader();

      let apiResult = yield addLeadsByRMAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_LEADS_BY_RM_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_LEADS,
          payload: currentFilter,
          pagination: { page: 0, limit: 20, loadMore: false }
        });

        if (result.data && result.data.id) {
          yield put({
            type: actions.FETCH_LEADS_BY_ID,
            id: result.data.id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_LEADS_BY_RM_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_LEADS_BY_RM_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_LEADS_BY_RM_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addLeadsFromSuspectedDuplicates() {
  yield takeEvery('ADD_LEADS_FROM_SUSPECTED_DUPLICATES', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_LEADS_FROM_SUSPECTED_DUPLICATES,
        loading: true
      });

      const state = yield select();
      const currentFilter = state.AccountOfficer.leadsMgmtFilter;
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield addLeadsFromSuspectedDuplicatedsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_LEADS_FROM_SUSPECTED_DUPLICATES_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_LEADS,
          payload: currentFilter,
          pagination: { page: 0, limit: 20, loadMore: false }
        });

        if (result.data && result.data.id) {
          yield put({
            type: actions.FETCH_LEADS_BY_ID,
            id: result.data.id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_LEADS_FROM_SUSPECTED_DUPLICATES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_LEADS_FROM_SUSPECTED_DUPLICATES_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_LEADS_FROM_SUSPECTED_DUPLICATES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* rejectLeadsFromSuspectedDuplicates() {
  yield takeEvery('REJECT_LEADS_FROM_SUSPECTED_DUPLICATES', function* ({ payload }) {
    try {
      yield put({
        type: actions.REJECTING_LEADS_FROM_SUSPECTED_DUPLICATES,
        loading: true
      });

      const state = yield select();
      const currentFilter = state.AccountOfficer.leadsMgmtFilter;
      const allSuspectedDuplicateLeadsFilter =
        state.AccountOfficer.allSuspectedDuplicateLeadsFilter;

      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield rejectLeadsFromSuspectedDuplicatedsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REJECT_LEADS_FROM_SUSPECTED_DUPLICATES_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_LEADS,
          payload: currentFilter,
          pagination: { page: 0, limit: 20, loadMore: false }
        });

        if (result.data && result.data.id) {
          yield put({
            type: actions.FETCH_LEADS_BY_ID,
            id: result.data.id
          });
        }
        yield put({
          type: actions.FETCH_ALL_SUSPECTED_DUPLICATE_LEADS,
          payload: allSuspectedDuplicateLeadsFilter,
          pagination: { page: 0, limit: 20 }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REJECT_LEADS_FROM_SUSPECTED_DUPLICATES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REJECT_LEADS_FROM_SUSPECTED_DUPLICATES_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REJECT_LEADS_FROM_SUSPECTED_DUPLICATES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* approveLeadSanitation() {
  yield takeEvery('APPROVE_LEAD_SANITATION', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.APPROVING_LEAD_SANITATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield approveLeadSanitationAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.APPROVE_LEAD_SANITATION_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_LEADS_SANITATION
        });
        yield put({
          type: actions.FETCH_LEAD_SANITATION_BY_ID,
          payload: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.APPROVE_LEAD_SANITATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.APPROVE_LEAD_SANITATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.APPROVE_LEAD_SANITATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* rejectLeadSanitation() {
  yield takeEvery('REJECT_LEAD_SANITATION', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.REJECTING_LEAD_SANITATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield rejectLeadSanitationAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.REJECT_LEAD_SANITATION_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_LEADS_SANITATION
        });
        yield put({
          type: actions.FETCH_LEAD_SANITATION_BY_ID,
          payload: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REJECT_LEAD_SANITATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REJECT_LEAD_SANITATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REJECT_LEAD_SANITATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* approveLeadSanitationLeadsManagement() {
  yield takeEvery('APPROVE_LEAD_SANITATION_LEADS_MANAGEMENT', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.APPROVING_LEAD_SANITATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield approveLeadSanitationAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.APPROVE_LEAD_SANITATION_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_LEADS
        });
        yield put({
          type: actions.FETCH_LEADS_BY_ID,
          id: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.APPROVE_LEAD_SANITATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.APPROVE_LEAD_SANITATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.APPROVE_LEAD_SANITATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* rejectLeadSanitationLeadsManagement() {
  yield takeEvery('REJECT_LEAD_SANITATION_LEADS_MANAGEMENT', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.REJECTING_LEAD_SANITATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield rejectLeadSanitationAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.REJECT_LEAD_SANITATION_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_LEADS
        });
        yield put({
          type: actions.FETCH_LEADS_BY_ID,
          id: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REJECT_LEAD_SANITATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REJECT_LEAD_SANITATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REJECT_LEAD_SANITATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllLeads() {
  yield takeEvery('FETCH_ALL_LEADS', function* ({ payload }) {
    try {
      const pagination = payload.pagination
      const loadMore = pagination.loadMore;
      if (loadMore) {
        yield put({
          type: actions.LOADING_MORE_LEAD_PROFILES
        });
      } else {
        yield put({
          type: actions.FETCHING_ALL_LEADS,
          loading: true
        });
        yield put({
          type: actions.RESET_ACTIVE_LEAD_BY_ID
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const currentList = pagination.currentLeadList && loadMore ? pagination.currentLeadList : [];

      const apiResult = yield fetchAllLeadsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0 ? currentList.concat(result.data) : result.data;
      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_LEADS_SUCCESS,
          loading: false,
          result: parseData,
          pagination: result ? result.pagination : null,
          filter: payload
        });

        if (parseData.length > 0 && parseData[0] && parseData[0].id) {
          yield put({
            type: actions.FETCH_LEADS_BY_ID,
            id: parseData[0].id
          });
        }
      } else {
        yield put({
          type: actions.FETCH_ALL_LEADS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_LEADS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchAllUploadedLeadsFileData() {
  yield takeEvery('FETCH_ALL_UPLOADED_LEADS_FILE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_ALL_UPLOADED_LEADS_FILE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllUploadedLeadsFileDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_UPLOADED_LEADS_FILE_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null,
          pagination: result ? result.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_ALL_UPLOADED_LEADS_FILE_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_UPLOADED_LEADS_FILE_DATA_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchAllSuspectedDuplicateLeads() {
  yield takeEvery('FETCH_ALL_SUSPECTED_DUPLICATE_LEADS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_ALL_SUSPECTED_DUPLICATE_LEADS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllSuspectedDuplicateLeadsAPI(
        payload,
        roleHeaderAuth
      );

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_SUSPECTED_DUPLICATE_LEADS_SUCCESS,
          loading: false,
          result: result ? result.data : null,
          pagination: result ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_ALL_SUSPECTED_DUPLICATE_LEADS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_SUSPECTED_DUPLICATE_LEADS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchLeadsByID() {
  yield takeEvery('FETCH_LEADS_BY_ID', function* ({ id }) {
    try {
      yield put({
        type: actions.FETCHING_LEADS_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchLeadsByIDAPI(id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_LEADS_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
        yield put({
          type: actions.FETCH_LEAD_LOGS,
          id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        yield put({
          type: actions.FETCH_LEADS_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LEADS_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchLeadLogs() {
  yield takeEvery('FETCH_LEAD_LOGS', function* ({ id, pagination }) {
    try {
      const loadMore = pagination.loadMore;
      if (loadMore) {
        yield put({
          type: actions.LOADING_MORE_LEAD_LOGS
        });
      } else {
        yield put({
          type: actions.FETCHING_LEAD_LOGS,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchLeadLogsAPI(id, pagination, roleHeaderAuth);
      const currentList = pagination.currentData && loadMore ? pagination.currentData : [];

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_LEAD_LOGS_SUCCESS,
          loading: false,
          result: result?.data?.logs,
          pagination: result ? result.data.pagination : null,
          loadMore
        });
      } else {
        yield put({
          type: actions.FETCH_LEAD_LOGS_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LEAD_LOGS_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}

export function* editLeads() {
  yield takeEvery('EDIT_LEADS', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_LEADS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editLeadProfileAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_LEADS_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_LEADS
        });
        yield put({
          type: actions.FETCH_LEADS_BY_ID,
          id: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_LEADS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_LEADS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_LEADS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editLeadSanitation() {
  yield takeEvery('EDIT_LEAD_SANITATION', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_LEADS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editLeadSanitationProfileAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_LEAD_SANITATION_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_LEADS_SANITATION
        });
        yield put({
          type: actions.FETCH_LEAD_SANITATION_BY_ID,
          payload: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_LEAD_SANITATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_LEAD_SANITATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_LEADS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* changeStatusNurturing() {
  yield takeEvery('CHANGE_STATUS_NURTURING', function* ({ payload }) {
    try {
      yield put({
        type: actions.CHANGING_STATUS_NURTURING,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield changeStatusNurturingAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CHANGE_STATUS_NURTURING_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_LEADS
        });
        yield put({
          type: actions.FETCH_LEADS_BY_ID,
          payload
        });
        yield put({
          type: actions.FETCH_ALL_LEADS_NURTURING,
          payload: {
            page: 0,
            limit: 20
          },
          currentList: null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CHANGE_STATUS_NURTURING_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CHANGE_STATUS_NURTURING_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CHANGE_STATUS_NURTURING_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllLeadsNurturing() {
  yield takeEvery('FETCH_ALL_LEADS_NURTURING', function* ({ payload, currentList }) {
    try {
      if (payload && payload.loadMore) {
        yield put({
          type: actions.LOADING_MORE_LEADS_NURTURING,
          loading: true
        });
      } else {
        yield put({
          type: actions.FETCHING_ALL_LEADS_NURTURING,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllLeadsNurturingAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      const listData = currentList && payload.loadMore && currentList.length > 0 ? currentList : [];
      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_LEADS_NURTURING_SUCCESS,
          loading: false,
          result: parseData,
          pagination: result.pagination,
          filter: {
            ...payload
          }
        });

        if (parseData.length > 0 && parseData[0] && parseData[0].id) {
          yield put({
            type: actions.FETCH_LEAD_NURTURING_BY_ID,
            id: parseData[0].id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_ALL_LEADS_NURTURING_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_LEADS_NURTURING_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_LEADS_NURTURING_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchLeadNurturingByID() {
  yield takeEvery('FETCH_LEAD_NURTURING_BY_ID', function* ({ id }) {
    try {
      yield put({
        type: actions.FETCHING_LEAD_NURTURING_BY_ID,
        loading: true
      });
      const state = yield select();
      const currentDateSelected = state.AccountOfficer.currentDateSelected;
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchLeadNurturingByIDAPI(id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_LEAD_NURTURING_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });

        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_CALENDAR_DATA,
          payload: {
            date: isoDateFormatter(DATEFORMATTER.DATE_ONLY, currentDateSelected),
            lead_id: id
          }
        });

        yield put({
          type: actions.FETCH_LEAD_LOGS,
          id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        yield put({
          type: actions.FETCH_LEAD_NURTURING_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LEAD_NURTURING_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchLeadNurturingRequestByID() {
  yield takeEvery('FETCH_LEAD_NURTURING_REQUEST_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_LEAD_NURTURING_REQUEST_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchLeadNurturingRequestByIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_LEAD_NURTURING_REQUEST_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_LEAD_NURTURING_REQUEST_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LEAD_NURTURING_REQUEST_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateLeadNurturing() {
  yield takeEvery('UPDATE_LEAD_NURTURING', function* ({ urls, payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_LEAD_NURTURING,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();

      let finalDataForUpload = [];
      if (payload && payload.files && payload.files.length === urls.length) {
        const dataFile = payload.files;
        dataFile.forEach(file => {
          if (urls.some(str => str.includes(file.name))) {
            let getURL = urls.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              finalDataForUpload.push(currentObj);
            }
          }
        });

        yield delay(urls.length * 1000);
      }

      const apiResult = yield updateLeadNurturingAPI(
        { ...payload, files: finalDataForUpload },
        id,
        roleHeaderAuth
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_LEAD_NURTURING_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_LEAD_NURTURING_BY_ID,
          id: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_LEAD_NURTURING_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_LEAD_NURTURING_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_LEAD_NURTURING_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* triggerLeadNurturingExemptionRequest() {
  yield takeEvery('TRIGGER_LEAD_NURTURING_EXEMPTION_REQUEST', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.TRIGGERING_LEAD_NURTURING_EXEMPTION_REQUEST,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield triggerLeadNurturingExemptionRequestAPI(
        { ...payload },
        id,
        roleHeaderAuth
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.TRIGGER_LEAD_NURTURING_EXEMPTION_REQUEST_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_LEAD_NURTURING_BY_ID,
          id: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.TRIGGER_LEAD_NURTURING_EXEMPTION_REQUEST_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.TRIGGER_LEAD_NURTURING_EXEMPTION_REQUEST_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_LEAD_NURTURING_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addIntegrationFormRequest() {
  yield takeEvery('ADD_INTEGRATION_FORM_REQUEST', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.ADDING_INTEGRATION_FORM_REQUEST,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();

      let filesData = [];
      if (payload && payload?.irf_purpose === "prod" && payload.files && payload.files.length === urls.length) {
        const dataFile = payload.files;
        dataFile.forEach(file => {
          if (urls.some(str => str.includes(file.name))) {
            let getURL = urls.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              filesData.push(currentObj);
            }
          }
        });
      
        yield delay(urls.length * 1000);

      }

      const apiResult = yield addIntegrationFormRequestAPI(
        { ...payload, files: filesData },
        roleHeaderAuth
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.ADD_INTEGRATION_FORM_REQUEST_SUCCESS,
          loading: false,
          message: result.message
        });

        // yield put({
        //   type: actions.FETCH_LEAD_NURTURING_BY_ID,
        //   payload: id
        // });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_INTEGRATION_FORM_REQUEST_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_INTEGRATION_FORM_REQUEST_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_LEAD_NURTURING_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* getURLSforUploadedLeadFiles() {
  yield takeEvery('STORE_ATTACHED_LEAD_FILES_FOR_UPLOAD', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_ATTACHED_LEAD_FILES_FOR_UPLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getURLsForLeadFilesAPI(key, files, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.STORE_ATTACHED_LEAD_FILES_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.STORE_ATTACHED_LEAD_FILES_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_ATTACHED_LEAD_FILES_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* getURLSforUploadedLeadChangeStatusFiles() {
  yield takeEvery('STORE_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getURLsForLeadFilesAPI(key, files, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.STORE_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.STORE_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* getURLSforUploadedLeadActivityFiles() {
  yield takeEvery('STORE_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD,
        loading: true
      });

      const state = yield select();
      const presignedUrlsForLeadActivityFileData =
        state.AccountOfficer.presignedUrlsForLeadActivityFileData;

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getURLsForLeadFilesAPI(key, files, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (
          presignedUrlsForLeadActivityFileData &&
          presignedUrlsForLeadActivityFileData.length > 0
        ) {
          urlsArr.push(...presignedUrlsForLeadActivityFileData);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* sendLeadDiscussion() {
  yield takeEvery('SEND_LEAD_DISCUSSION_ITEM', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.SENDING_LEAD_DISCUSSION_ITEM,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const state = yield select();
      const leadDiscussionData = state.AccountOfficer.leadDiscussionData;
      let finalDataForUpload = [];
      if (payload && payload.files.length === urls.length) {
        const dataFile = payload.files;
        dataFile.forEach(file => {
          if (urls.some(str => str.includes(file.name))) {
            let getURL = urls.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              finalDataForUpload.push(currentObj);
            }
          }
        });

        yield delay(urls.length * 1000);
      }

      if (payload.lead_id) {
        const apiResult = yield sendLeadDiscussionAPI(
          {
            files: finalDataForUpload,
            lead_id: payload.lead_id,
            reply_to: payload.reply_to,
            mentions: payload.mentions,
            message: payload.message,
            module: payload.module,
            topic: payload.topic
          },
          roleHeaderAuth
        );
        const result = apiResult.data;
        if (result.success) {
          yield put({
            type: actions.SEND_LEAD_DISCUSSION_ITEM_SUCCESS,
            loading: false,
            message: result.message
          });
          if (payload && payload.lead_id && leadDiscussionData) {
            yield put({
              type: actions.FETCH_LEAD_DISCUSSIONS,
              payload: {
                lead_id: payload.lead_id
              },
              currentList: leadDiscussionData
            });
          }
        } else {
          if (result.status === 404) {
            yield put({
              type: actions.SEND_LEAD_DISCUSSION_ITEM_FAILED,
              message: `Endpoint ${result.title}`,
              loading: false
            });
          } else if (result.status === 413) {
            yield put({
              type: actions.SEND_LEAD_DISCUSSION_ITEM_FAILED,
              message: `Your request exceeded the system limit size`,
              loading: false
            });
          } else {
            yield put({
              type: actions.SEND_LEAD_DISCUSSION_ITEM_FAILED,
              message: result.message,
              loading: false
            });
          }
        }
      } else {
        yield put({
          type: actions.SEND_LEAD_DISCUSSION_ITEM_FAILED,
          message: `Your message failed to send due to an issue. Please try again later`,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.SEND_LEAD_DISCUSSION_ITEM_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* likeLeadDiscussion() {
  yield takeEvery('LIKE_LEAD_DISCUSSION_DATA', function* ({ id, payload }) {
    try {
      yield put({
        type: actions.LIKING_LEAD_DISCUSSION_DATA,
        loading: true
      });

      yield put({
        type: actions.LIKE_LEAD_DISCUSSION_CURRENT_ID,
        payload: id
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield likeLeadDiscussionAPI(id, payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.LIKE_LEAD_DISCUSSION_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        if (payload && payload.lead_id) {
          yield put({
            type: actions.FETCH_LEAD_LOGS,
            id: payload.lead_id,
            pagination: {
              page: 0,
              limit: 20
            }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.LIKE_LEAD_DISCUSSION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.LIKE_LEAD_DISCUSSION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.LIKE_LEAD_DISCUSSION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchLeadDiscussions() {
  yield takeEvery('FETCH_LEAD_DISCUSSIONS', function* ({ payload, currentList }) {
    try {
      if (payload && payload.loadMore) {
        yield put({
          type: actions.LOAD_MORE_LEAD_DISCUSSIONS,
          loading: true
        });
      } else {
        yield put({
          type: actions.FETCHING_LEAD_DISCUSSIONS,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchLeadDiscussionAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      const listData = currentList && payload.loadMore && currentList.length > 0 ? currentList : [];
      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;
      const finalData = filterDuplicateData(parseData);

      if (result.success) {
        yield put({
          type: actions.FETCH_LEAD_DISCUSSIONS_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result.pagination,
          filter: {
            ...payload
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_LEAD_DISCUSSIONS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_LEAD_DISCUSSIONS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LEAD_DISCUSSIONS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadLeadAttachment() {
  yield takeEvery('DOWNLOAD_LEAD_DISCUSSION_ATTACHMENT', function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_LEAD_DISCUSSION_ATTACHMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadLeadAttachmentAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_LEAD_DISCUSSION_ATTACHMENT_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
          // window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_LEAD_DISCUSSION_ATTACHMENT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_LEAD_DISCUSSION_ATTACHMENT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_LEAD_DISCUSSION_ATTACHMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadLeadChangeStatusAttachment() {
  yield takeEvery('DOWNLOAD_LEAD_CHANGE_STATUS_ATTACHMENT', function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_LEAD_CHANGE_STATUS_ATTACHMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadLeadChangeStatusAttachmentAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_LEAD_CHANGE_STATUS_ATTACHMENT_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
          // window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_LEAD_CHANGE_STATUS_ATTACHMENT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_LEAD_CHANGE_STATUS_ATTACHMENT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_LEAD_CHANGE_STATUS_ATTACHMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadLeadActivityAttachment() {
  yield takeEvery('DOWNLOAD_LEAD_ACTIVITY_ATTACHMENT', function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_LEAD_ACTIVITY_ATTACHMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadLeadActivityAttachmentAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_LEAD_ACTIVITY_ATTACHMENT_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
          // window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_LEAD_ACTIVITY_ATTACHMENT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_LEAD_ACTIVITY_ATTACHMENT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_LEAD_ACTIVITY_ATTACHMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllLeadSanitation() {
  yield takeEvery('FETCH_ALL_LEADS_SANITATION', function* ({ payload, currentList }) {
    try {
      if (payload && payload.loadMore) {
        yield put({
          type: actions.LOADING_MORE_LEADS_SANITATION,
          loading: true
        });
      } else {
        yield put({
          type: actions.FETCHING_ALL_LEADS_SANITATION,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllLeadSanitationAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      const listData = currentList && payload.loadMore && currentList.length > 0 ? currentList : [];
      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;
      const finalData = filterDuplicateData(parseData);

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_LEADS_SANITATION_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result.pagination,
          filter: {
            ...payload
          }
        });
        if (finalData.length > 0) {
          yield put({
            type: actions.FETCH_LEAD_SANITATION_BY_ID,
            payload:
              finalData.length > 0 && finalData[0] && finalData[0].id ? finalData[0].id : null
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_ALL_LEADS_SANITATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_LEADS_SANITATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_LEADS_SANITATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchLeadSanitationByID() {
  yield takeEvery('FETCH_LEAD_SANITATION_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_LEAD_SANITATION_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchLeadSanitationByIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_LEAD_SANITATION_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_LEAD_SANITATION_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LEAD_SANITATION_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addLeadMerchantData() {
  yield takeEvery('ADD_LEAD_MERCHANT_DATA', function* ({ payload, currentFilter }) {
    try {
      yield put({
        type: actions.ADDING_LEAD_MERCHANT_DATA,
        loading: true
      });
      const state = yield select();
      const currentPagination = state.AccountOfficer.listPagination;
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addLeadMerchantDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_LEAD_MERCHANT_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_LIST_DATA,
          payload: currentFilter,
          pagination: {
            page: currentPagination.current_page,
            limit: currentPagination.page_size
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_LEAD_MERCHANT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_LEAD_MERCHANT_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_LEAD_MERCHANT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addFarmingLeadMerchantData() {
  yield takeEvery('ADD_FARMING_LEAD_MERCHANT_DATA', function* ({ payload, currentFilter }) {
    try {
      yield put({
        type: actions.ADDING_FARMING_LEAD_MERCHANT_DATA,
        loading: true
      });
      const state = yield select();
      const currentPagination = state.AccountOfficer.listPagination;
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addFarmingLeadMerchantDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_FARMING_LEAD_MERCHANT_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_LIST_DATA,
          payload: currentFilter,
          pagination: {
            page: currentPagination.current_page,
            limit: currentPagination.page_size
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_FARMING_LEAD_MERCHANT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_FARMING_LEAD_MERCHANT_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_FARMING_LEAD_MERCHANT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchAllMerchantDataList() {
  yield takeEvery('FETCH_ALL_MERCHANT_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_ALL_MERCHANT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchAllMerchantAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_MERCHANT_DATA_SUCCESS,
          loading: false,
          result: result
            ? {
                leads: result.leads,
                merchants: result.merchants
              }
            : null
        });
      } else {
        yield put({
          type: actions.FETCH_ALL_MERCHANT_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_MERCHANT_DATA_FAILED,
        loading: false
      });
    }
  });
}

export function* addAppointmentData() {
  yield takeEvery('ADD_APPOINTMENT_DATA', function* ({ urls, payload, currentDate }) {
    try {
      yield put({
        type: actions.ADDING_APPOINTMENT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let finalDataForUpload = [];
      if (payload && urls && payload.files && payload.files.length === urls.length) {
        const dataFile = payload.files;
        dataFile.forEach(file => {
          if (urls.some(str => str.includes(file.name))) {
            let getURL = urls.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              finalDataForUpload.push(currentObj);
            }
          }
        });

        yield delay(urls.length * 1000);
      }

      const apiResult = yield addAppointmentDataAPI(
        { ...payload, files: finalDataForUpload },
        roleHeaderAuth
      );

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_APPOINTMENT_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_CALENDAR_DATA,
          payload: {
            date: currentDate,
            lead_id: payload.lead_id
          }
        });
        yield put({
          type: actions.FETCH_LEAD_LOGS,
          id: payload.lead_id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
        yield put({
          type: actions.FETCH_LEAD_NURTURING_BY_ID,
          id: payload.lead_id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_APPOINTMENT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_APPOINTMENT_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_APPOINTMENT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchTargetProjectionsData() {
  yield takeEvery('FETCH_TARGET_PROJECTIONS_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_TARGET_PROJECTIONS_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchTargetProjectionsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_TARGET_PROJECTIONS_DATA_SUCCESS,
          loading: false,
          filter: payload,
          result: result && result.data ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_TARGET_PROJECTIONS_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_TARGET_PROJECTIONS_DATA_FAILED,
        loading: false
      });
    }
  });
}
export function* fetchTargetProjectionsDataByTeam() {
  yield takeEvery('FETCH_TARGET_PROJECTIONS_DATA_BY_TEAM', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_TARGET_PROJECTIONS_DATA_BY_TEAM,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchTargetProjectionsByTeamAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_TARGET_PROJECTIONS_DATA_SUCCESS_BY_TEAM,
          loading: false,
          filter: payload,
          result: result && result.data ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_TARGET_PROJECTIONS_DATA_FAILED_BY_TEAM,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_TARGET_PROJECTIONS_DATA_FAILED_BY_TEAM,
        loading: false
      });
    }
  });
}
export function* addMonthlyTargetData() {
  yield takeEvery('ADD_MONTHLY_TARGET_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_MONTHLY_TARGET_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const state = yield select();
      const targetFilter = state.AccountOfficer.targetFilter;
      const apiResult = yield addMonthlyTargetAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_MONTHLY_TARGET_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.RESET_TARGET_PROJECTIONS_DATA
        });
        if (targetFilter && targetFilter.isTeam) {
          yield put({
            type: actions.FETCH_TARGET_PROJECTIONS_DATA_BY_TEAM,
            payload: targetFilter
          });
        } else {
          yield put({
            type: actions.FETCH_TARGET_PROJECTIONS_DATA,
            payload: targetFilter
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_MONTHLY_TARGET_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_MONTHLY_TARGET_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_MONTHLY_TARGET_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addCustomerVisitData() {
  yield takeEvery('ADD_CUSTOMER_VISIT_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_CUSTOMER_VISIT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const state = yield select();
      const targetFilter = state.AccountOfficer.targetFilter;
      const apiResult = yield addCustomerVisitAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_CUSTOMER_VISIT_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.RESET_TARGET_PROJECTIONS_DATA
        });
        if (targetFilter && targetFilter.isTeam) {
          yield put({
            type: actions.FETCH_TARGET_PROJECTIONS_DATA_BY_TEAM,
            payload: targetFilter
          });
        } else {
          yield put({
            type: actions.FETCH_TARGET_PROJECTIONS_DATA,
            payload: targetFilter
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_CUSTOMER_VISIT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_CUSTOMER_VISIT_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_CUSTOMER_VISIT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editAppointmentData() {
  yield takeEvery('EDIT_APPOINTMENT_DATA', function* ({ urls, payload, id, currentFilter }) {
    try {
      yield put({
        type: actions.EDITING_APPOINTMENT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let finalDataForUpload = [];
      if (payload && urls && payload.files && payload.files.length === urls.length) {
        const dataFile = payload.files;
        dataFile.forEach(file => {
          if (urls.some(str => str.includes(file.name))) {
            let getURL = urls.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              finalDataForUpload.push(currentObj);
            }
          }
        });

        yield delay(urls.length * 1000);
      }

      const apiResult = yield editAppointmentDataAPI(
        { ...payload, files: finalDataForUpload },
        id,
        roleHeaderAuth
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_APPOINTMENT_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_CALENDAR_DATA,
          payload: currentFilter
        });
        yield put({
          type: actions.FETCH_LEAD_LOGS,
          id: payload.lead_id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_APPOINTMENT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_APPOINTMENT_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_APPOINTMENT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateMonthlyTargetData() {
  yield takeEvery('UPDATE_MONTHLY_TARGET_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_MONTHLY_TARGET_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const state = yield select();
      const targetFilter = state.AccountOfficer.targetFilter;
      const apiResult = yield updateMonthlyTargetAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_MONTHLY_TARGET_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_TARGET_PROJECTIONS_DATA,
          payload: targetFilter
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_MONTHLY_TARGET_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_MONTHLY_TARGET_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_MONTHLY_TARGET_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* updateCustomerVisitData() {
  yield takeEvery('UPDATE_CUSTOMER_VISIT_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_CUSTOMER_VISIT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const state = yield select();
      const targetFilter = state.AccountOfficer.targetFilter;
      const apiResult = yield updateCustomerVisitAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_CUSTOMER_VISIT_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_TARGET_PROJECTIONS_DATA,
          payload: targetFilter
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_CUSTOMER_VISIT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_CUSTOMER_VISIT_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_CUSTOMER_VISIT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* completionOfMerchantDetails() {
  yield takeEvery('COMPLETE_MERCHANT_DETAILS', function* ({ payload, id, filter }) {
    try {
      yield put({
        type: actions.COMPLETING_MERCHANT_DETAILS,
        loading: true
      });
      const state = yield select();
      const currentPagination = state.AccountOfficer.listPagination;
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield completeMerchantDetailAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success && currentPagination) {
        yield put({
          type: actions.COMPLETE_MERCHANT_DETAILS_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_LIST_DATA,
          payload: filter,
          pagination: {
            page: currentPagination.current_page,
            limit: currentPagination.page_size
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.COMPLETE_MERCHANT_DETAILS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.COMPLETE_MERCHANT_DETAILS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.COMPLETE_MERCHANT_DETAILS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* completionOfFarmingMerchantDetails() {
  yield takeEvery('COMPLETE_FARMING_MERCHANT_DETAILS', function* ({ payload, id, filter }) {
    try {
      yield put({
        type: actions.COMPLETING_FARMING_MERCHANT_DETAILS,
        loading: true
      });
      const state = yield select();
      const currentPagination = state.AccountOfficer.listPagination;
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield completeFarmingMerchantDetailAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success && currentPagination) {
        yield put({
          type: actions.COMPLETE_FARMING_MERCHANT_DETAILS_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_LEAD_MANAGEMENT_LIST_DATA,
          payload: filter,
          pagination: {
            page: currentPagination.current_page,
            limit: currentPagination.page_size
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.COMPLETE_FARMING_MERCHANT_DETAILS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.COMPLETE_FARMING_MERCHANT_DETAILS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.COMPLETE_FARMING_MERCHANT_DETAILS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* passStatusRequirementData() {
  yield takeEvery('PASS_STATUS_REQUIREMENT_DATA_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.PASSING_STATUS_REQUIREMENT_DATA_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield passStatusRequirementDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.PASS_STATUS_REQUIREMENT_DATA_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: dashboardActions.RESET_APPROVAL_REQUESTS
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.PASS_STATUS_REQUIREMENT_DATA_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else if (result.status === 413) {
          yield put({
            type: actions.PASS_STATUS_REQUIREMENT_DATA_DATA_FAILED,
            message: `Your request exceeded the system limit size`,
            loading: false
          });
        } else {
          yield put({
            type: actions.PASS_STATUS_REQUIREMENT_DATA_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.PASS_STATUS_REQUIREMENT_DATA_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchRequirementByMerchantID() {
  yield takeEvery('FETCH_REQUIREMENT_BY_MERCHANT_ID_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_REQUIREMENT_BY_MERCHANT_ID_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchRequirementByMerchantIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_REQUIREMENT_BY_MERCHANT_ID_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_REQUIREMENT_BY_MERCHANT_ID_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            result: [],
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_REQUIREMENT_BY_MERCHANT_ID_DATA_FAILED,
            result: [],
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_REQUIREMENT_BY_MERCHANT_ID_DATA_FAILED,
        loading: false,
        result: []
      });
    }
  });
}
export function* fetchStoryByMerchantIDData() {
  yield takeEvery('FETCH_STORY_BY_MERCHANT_ID_DATA', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_STORY_BY_MERCHANT_ID_DATA
        });
      } else {
        yield put({
          type: actions.FETCHING_STORY_BY_MERCHANT_ID_DATA,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchStoryByMerchantIDAPI(payload, pagination, roleHeaderAuth);
      const currentList =
        pagination.currentNotification && loadmore ? pagination.currentNotification : [];

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0 ? currentList.concat(result.data) : result.data;

      const finalData = parseData ? filterDuplicateData(parseData) : [];

      if (result.success) {
        yield put({
          type: actions.FETCH_STORY_BY_MERCHANT_ID_DATA_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.pagination : null,
          payload: payload
        });
      } else {
        yield put({
          type: actions.FETCH_STORY_BY_MERCHANT_ID_DATA_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_STORY_BY_MERCHANT_ID_DATA_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}
export function* checkRequirmentStatusData() {
  yield takeEvery('CHECK_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.CHECKING_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield checkRequirmentStatusDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CHECK_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA_SUCCESS,
          loading: false,
          result: result.data ? result.data : null,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CHECK_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CHECK_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CHECK_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* downloadRequirementFileData() {
  yield takeEvery('DOWNLOAD_REQUIREMENT_FILE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_REQUIREMENT_FILE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadRequirementFileDataAPI(payload, roleHeaderAuth);
      const state = yield select();
      const fileDownloadData = state.AccountOfficer.fileDownloadData;

      const result = apiResult.data;

      if (!result.success) {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_REQUIREMENT_FILE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            payload: fileDownloadData
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_REQUIREMENT_FILE_DATA_FAILED,
            message: result.message,
            loading: false,
            payload: fileDownloadData
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_REQUIREMENT_FILE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false,
        payload: null
      });
    }
  });
}
function fetchRequirementByMerchantIDAPI(id, roleAuth) {
  return get(`get-all/validation-requirement/${id}`, null, null, null, null, roleAuth);
}
function fetchStoryByMerchantIDAPI(id, pagination, roleAuth) {
  return get(
    `get-all/merchant-story/${id}`,
    null,
    pagination ? pagination : { page: 0, limit: 10 },
    null,
    null,
    roleAuth
  );
}

export function* fetchMerchantStatus() {
  yield takeEvery('FETCH_MERCHANT_STATUS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_STATUS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchMerchantStatusAPI(roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_STATUS_SUCCESS,
          loading: false,
          result: result && result.data ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_MERCHANT_STATUS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null
          });
        } else {
          yield put({
            type: actions.FETCH_MERCHANT_STATUS_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_STATUS_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null
      });
    }
  });
}

export function* fetchMerchantServices() {
  yield takeEvery('FETCH_MERCHANT_SERVICES', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_SERVICES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchMerchantServicesAPI(roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_SERVICES_SUCCESS,
          loading: false,
          result: result && result.data ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_MERCHANT_SERVICES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null
          });
        } else {
          yield put({
            type: actions.FETCH_MERCHANT_SERVICES_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_SERVICES_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null
      });
    }
  });
}

export function* fetchInstallmentBankConfigurations() {
  yield takeEvery('FETCH_INSTALLMENT_BANK_CONFIGURATIONS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_INSTALLMENT_BANK_CONFIGURATIONS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchInstallmentBankConfigurationsAPI(roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_INSTALLMENT_BANK_CONFIGURATIONS_SUCCESS,
          loading: false,
          result: result && result.data ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_INSTALLMENT_BANK_CONFIGURATIONS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null
          });
        } else {
          yield put({
            type: actions.FETCH_INSTALLMENT_BANK_CONFIGURATIONS_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_INSTALLMENT_BANK_CONFIGURATIONS_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null
      });
    }
  });
}

export function* addMerchantStatus() {
  yield takeEvery('ADD_MERCHANT_STATUS', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_MERCHANT_STATUS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addMerchantStatusAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_MERCHANT_STATUS_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_MERCHANT_STATUS
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_MERCHANT_STATUS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_MERCHANT_STATUS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_MERCHANT_STATUS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editMerchantStatus() {
  yield takeEvery('EDIT_MERCHANT_STATUS', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_MERCHANT_STATUS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editMerchantStatusAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.EDIT_MERCHANT_STATUS_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_MERCHANT_STATUS
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MERCHANT_STATUS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MERCHANT_STATUS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MERCHANT_STATUS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editMerchantStatusNotificationSettings() {
  yield takeEvery('EDIT_MERCHANT_STATUS_NOTIFICATION_SETTINGS', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_MERCHANT_STATUS_NOTIFICATION_SETTINGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editMerchantStatusNotificationSettingsAPI(
        payload,
        id,
        roleHeaderAuth
      );

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.EDIT_MERCHANT_STATUS_NOTIFICATION_SETTINGS_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_MERCHANT_STATUS
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MERCHANT_STATUS_NOTIFICATION_SETTINGS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MERCHANT_STATUS_NOTIFICATION_SETTINGS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MERCHANT_STATUS_NOTIFICATION_SETTINGS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* changeMerchantStatus() {
  yield takeEvery('CHANGE_STATUS_MERCHANT_STATUS', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.CHANGING_STATUS_MERCHANT_STATUS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editMerchantStatusAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CHANGE_STATUS_MERCHANT_STATUS_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_MERCHANT_STATUS
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CHANGE_STATUS_MERCHANT_STATUS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CHANGE_STATUS_MERCHANT_STATUS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CHANGE_STATUS_MERCHANT_STATUS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* reorderMerchantStatusData() {
  yield takeEvery('REORDER_MERCHANT_STATUS_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.REORDERING_MERCHANT_STATUS_DATA,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield reorderMerchantStatusDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REORDER_MERCHANT_STATUS_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MERCHANT_STATUS
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REORDER_MERCHANT_STATUS_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REORDER_MERCHANT_STATUS_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REORDER_MERCHANT_STATUS_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* getS3UrlsExemptionFiles() {
  yield takeEvery('STORE_EXEMPTION_FILES_FOR_UPLOAD', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_EXEMPTION_FILES_FOR_UPLOAD,
        loading: true
      });
      const state = yield select();
      const presignedUrlsExemptionFiles = state.AccountOfficer.presignedUrlsExemptionFiles;

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getURLsForExemptionFilesAPI(key, files, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (presignedUrlsExemptionFiles && presignedUrlsExemptionFiles.length > 0) {
          urlsArr.push(...presignedUrlsExemptionFiles);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_EXEMPTION_FILES_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_EXEMPTION_FILES_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_EXEMPTION_FILES_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* manageExemptionFiles() {
  yield takeEvery('MANAGE_EXEMPTION_FILES', function* ({ urls, payload, id }) {
    try {
      yield put({
        type: actions.MANAGING_EXEMPTION_FILES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let exemptionFilesData = [];
      if (
        payload &&
        payload.exemption_files &&
        payload.exemption_files.length === urls.exemption_files.length
      ) {
        const dataFile = payload.exemption_files;
        dataFile.forEach(file => {
          if (urls.exemption_files.some(str => str.includes(file.name))) {
            let getURL = urls.exemption_files.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type,
                document_type: file.document_type
              };
              exemptionFilesData.push(currentObj);
            }
          }
        });

        yield delay(urls.exemption_files.length * 1000);
      }

      const apiResult = yield manageExemptionFilesAPI(
        {
          ...payload,
          exemption_files: exemptionFilesData
        },
        id,
        roleHeaderAuth
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.MANAGE_EXEMPTION_FILES_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_LEAD_NURTURING_REQUEST_BY_ID,
          payload: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.MANAGE_EXEMPTION_FILES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.MANAGE_EXEMPTION_FILES_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.MANAGE_EXEMPTION_FILES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchLeadMonitoring() {
  yield takeEvery('FETCH_LEAD_MONITORING', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_LEAD_MONITORING,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchLeadMonitoringAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_LEAD_MONITORING_SUCCESS,
          loading: false,
          result: result && result.data ? result.data : null,
          filter: payload,
          pagination: result ? result.pagination : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_LEAD_MONITORING_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null
          });
        } else {
          yield put({
            type: actions.FETCH_LEAD_MONITORING_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LEAD_MONITORING_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null
      });
    }
  });
}

export function* fetchRelationsManagerActivity() {
  yield takeEvery('FETCH_RELATIONS_MANAGER_LEAD_LOGS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_RELATIONS_MANAGER_LEAD_LOGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchRelationsManagerActivityAPI(
        payload,
        roleHeaderAuth
      );

      const result = apiResult.data;

      const logs = result?.data;
      const newLogs = logs?.map(log => {
        const value = typeof log.value === 'string' ? log.value : JSON.stringify(log.value);
        return { ...log, value };
      });

      if (result.success) {
        yield put({
          type: actions.FETCH_RELATIONS_MANAGER_LEAD_LOGS_SUCCESS,
          loading: false,
          result: result && newLogs ? newLogs : [],
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_RELATIONS_MANAGER_LEAD_LOGS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_RELATIONS_MANAGER_LEAD_LOGS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchAllMerchantManagement() {
  yield takeEvery('FETCH_ALL_MERCHANT_MANAGEMENT', function* ({ payload, currentList }) {
    try {
      if (payload && payload.loadMore) {
        yield put({
          type: actions.LOADING_MORE_MERCHANT_MANAGEMENT,
          loading: true
        });
      } else {
        yield put({
          type: actions.FETCHING_ALL_MERCHANT_MANAGEMENT,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllMerchantManagementAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      const listData = currentList && payload.loadMore && currentList.length > 0 ? currentList : [];
      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_MERCHANT_MANAGEMENT_SUCCESS,
          loading: false,
          result: parseData,
          pagination: result.pagination,
          filter: {
            ...payload
          }
        });

        if (parseData.length > 0 && parseData[0] && parseData[0].id) {
          yield put({
            type: actions.FETCH_MERCHANT_MANAGEMENT_BY_ID,
            payload: parseData[0].id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_ALL_MERCHANT_MANAGEMENT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_MERCHANT_MANAGEMENT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_MERCHANT_MANAGEMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* requestVatExemptReversalSales() {
  yield takeEvery('REQUEST_VAT_EXEMPT_REVERSAL_SALES', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.REQUESTING_VAT_EXEMPT_REVERSAL_SALES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      
      let reversalAttachment = [];
      if (
        payload &&
        payload.reversal_attachment &&
        urls &&
        urls.reversal_attachment &&
        payload.reversal_attachment.length === urls.reversal_attachment.length
      ) {
        const dataFile = payload.reversal_attachment;
        dataFile.forEach(file => {
          if (urls.reversal_attachment.some(str => str.includes(file.name))) {
            let getURL = urls.reversal_attachment.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              reversalAttachment.push(currentObj);
            }
          }
        });

        yield delay(urls.reversal_attachment.length * 1000);
      }

      const apiResult = yield requestVatReversalSalesAPI(
        { ...payload, reversal_attachment: reversalAttachment },
        roleHeaderAuth
      );
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.REQUEST_VAT_EXEMPT_REVERSAL_SALES_SUCCESS,
          loading: false,
          message: result.message
        });
        if (payload && payload.operations_id) {
          yield put({
            type: actions.FETCH_MERCHANT_MANAGEMENT_BY_ID,
            payload: payload.operations_id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REQUEST_VAT_EXEMPT_REVERSAL_SALES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REQUEST_VAT_EXEMPT_REVERSAL_SALES_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REQUEST_VAT_EXEMPT_REVERSAL_SALES_FAILED,
        message: 'Failed to process request vat reversal',
        loading: false
      });
    }
  });
}

export function* fetchReversalRequestByIDSales() {
  yield takeEvery('FETCH_REVERSAL_REQUEST_BY_ID_SALES', function* ({ id }) {
    try {
      yield put ({
        type: actions.FETCHING_REVERSAL_REQUEST_BY_ID_SALES,
        loading: true,
      });
      const roleHeaderAuth = yield getRoleHeader()
      const apiResult = yield fetchReversalRequestByIDSalesAPI(id, roleHeaderAuth)

      const result = apiResult.data

      if (result.success) {
        yield put ({
          type: actions.FETCH_REVERSAL_REQUEST_BY_ID_SALES_SUCCESS,
          result: result ? result.data : null,
          loading: false
        })
      } else {
        yield put({
          type: actions.FETCH_REVERSAL_REQUEST_BY_ID_SALES_FAILED,
          loading: false
      });
      }

    } catch (error) {
      yield put({
        type: actions.FETCH_REVERSAL_REQUEST_BY_ID_SALES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    } 
  });
}

export function* fetchMerchantManagementByID() {
  yield takeEvery('FETCH_MERCHANT_MANAGEMENT_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_MANAGEMENT_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantManagementByIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_MANAGEMENT_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });

        yield put({
          type: actions.FETCH_MIS_DATA_BY_ID,
          payload
        });

        if (result.data && result.data.lead_id) {
          yield put({
            type: actions.FETCH_LEAD_LOGS,
            id: result.data.lead_id,
            pagination: {
              page: 0,
              limit: 20
            }
          });
        }
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_MANAGEMENT_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_MANAGEMENT_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMISDataByID() {
  yield takeEvery('FETCH_MIS_DATA_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MIS_DATA_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMISDataByIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MIS_DATA_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
        if (result?.data?.business_type_id) {
          yield put({
            type: merchantAction.FETCH_BUSINESS_TYPE_REQUIREMENT,
            payload: { business_type_id: result?.data?.business_type_id }
          })
        }
      } else {
        yield put({
          type: actions.FETCH_MIS_DATA_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MIS_DATA_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* completeSalesReqInfo() {
  yield takeEvery('COMPLETE_SALES_REQ_INFO', function* ({ urls, payload, id }) {
    try {
      yield put({
        type: actions.COMPLETING_SALES_REQ_INFO,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let signedProposalData = [];
      if (
        payload &&
        payload.signed_proposal_files &&
        payload.signed_proposal_files.length === urls.signed_proposal_files.length
      ) {
        const dataFile = payload.signed_proposal_files;
        dataFile.forEach(file => {
          if (urls.signed_proposal_files.some(str => str.includes(file.name))) {
            let getURL = urls.signed_proposal_files.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              signedProposalData.push(currentObj);
            }
          }
        });

        yield delay(urls.signed_proposal_files.length * 1000);
      }

      let signedPSAData = [];
      if (
        payload &&
        payload.signed_psa_files &&
        payload.signed_psa_files.length === urls.signed_psa_files.length
      ) {
        const dataFile = payload.signed_psa_files;
        dataFile.forEach(file => {
          if (urls.signed_psa_files.some(str => str.includes(file.name))) {
            let getURL = urls.signed_psa_files.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              signedPSAData.push(currentObj);
            }
          }
        });

        yield delay(urls.signed_psa_files.length * 1000);
      }

      let vatExemptionData = [];
      if (
        payload &&
        payload.vat_exemption_files &&
        payload.vat_exemption_files.length === urls.vat_exemption_files.length
      ) {
        const dataFile = payload.vat_exemption_files;
        dataFile.forEach(file => {
          if (urls.vat_exemption_files.some(str => str.includes(file.name))) {
            let getURL = urls.vat_exemption_files.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              vatExemptionData.push(currentObj);
            }
          }
        });

        yield delay(urls.vat_exemption_files.length * 1000);
      }

      let wiredTransactionData = [];
      if (
        payload &&
        payload.wired_transaction_files &&
        payload.wired_transaction_files.length === urls.wired_transaction_files.length
      ) {
        const dataFile = payload.wired_transaction_files;
        dataFile.forEach(file => {
          if (urls.wired_transaction_files.some(str => str.includes(file.name))) {
            let getURL = urls.wired_transaction_files.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              wiredTransactionData.push(currentObj);
            }
          }
        });

        yield delay(urls.wired_transaction_files.length * 1000);
      }

      const apiResult = yield completeSalesReqInfoAPI(
        {
          ...payload,
          signed_proposal_files: signedProposalData,
          signed_psa_files: signedPSAData,
          vat_exemption_files: vatExemptionData,
          wired_transaction_files: wiredTransactionData
        },
        id,
        roleHeaderAuth
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.COMPLETE_SALES_REQ_INFO_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_MERCHANT_MANAGEMENT_BY_ID,
          payload: payload.merchant_mgmt_id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.COMPLETE_SALES_REQ_INFO_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.COMPLETE_SALES_REQ_INFO_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.COMPLETE_SALES_REQ_INFO_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* triggerInvoice() {
  yield takeEvery('TRIGGER_INVOICE_CREATION', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.TRIGGERING_INVOICE_CREATION,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield triggerInvoiceAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.TRIGGER_INVOICE_CREATION_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_MERCHANT_MANAGEMENT_BY_ID,
          payload: payload.merchant_mgmt_id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.TRIGGER_INVOICE_CREATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.TRIGGER_INVOICE_CREATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.TRIGGER_INVOICE_CREATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* sendMISFormLink() {
  yield takeEvery('SEND_MIS_FORM_LINK', function* ({ payload }) {
    try {
      yield put({
        type: actions.SENDING_MIS_FORM_LINK,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield sendMISFormLinkAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.SEND_MIS_FORM_LINK_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_MERCHANT_MANAGEMENT_BY_ID,
          payload: payload.merchant_mgmt_id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.SEND_MIS_FORM_LINK_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.SEND_MIS_FORM_LINK_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.SEND_MIS_FORM_LINK_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* resendMISLink() {
  yield takeEvery(actions.RESEND_MIS_LINK, function* ({ payload, id }) {
    try {
      yield put({
        type: actions.RESENDING_MIS_LINK,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield resendMISLinkAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.RESEND_MIS_LINK_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_MERCHANT_MANAGEMENT_BY_ID,
          payload: payload.merchant_management_id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.RESEND_MIS_LINK_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.RESEND_MIS_LINK_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.RESEND_MIS_LINK_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* getS3UrlsSignedProposal() {
  yield takeEvery('STORE_SIGNED_PROPOSAL_FOR_UPLOAD', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_SIGNED_PROPOSAL_FOR_UPLOAD,
        loading: true
      });
      const state = yield select();
      const presignedUrlsSignedProposal = state.AccountOfficer.presignedUrlsSignedProposal;

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getURLsForLeadFilesAPI(key, files, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (presignedUrlsSignedProposal && presignedUrlsSignedProposal.length > 0) {
          urlsArr.push(...presignedUrlsSignedProposal);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_SIGNED_PROPOSAL_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_SIGNED_PROPOSAL_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_SIGNED_PROPOSAL_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* getS3UrlsSignedPSA() {
  yield takeEvery('STORE_SIGNED_PSA_FOR_UPLOAD', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_SIGNED_PSA_FOR_UPLOAD,
        loading: true
      });
      const state = yield select();
      const presignedUrlsSignedPSA = state.AccountOfficer.presignedUrlsSignedPSA;

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getURLsForLeadFilesAPI(key, files, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (presignedUrlsSignedPSA && presignedUrlsSignedPSA.length > 0) {
          urlsArr.push(...presignedUrlsSignedPSA);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_SIGNED_PSA_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_SIGNED_PSA_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_SIGNED_PSA_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* downloadSignedProposalFile() {
  yield takeEvery('DOWNLOAD_SIGNED_PROPOSAL_FILE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.DOWNLOADING_SIGNED_PROPOSAL_FILE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadSignedProposalFileAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_SIGNED_PROPOSAL_FILE_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }

        yield put({
          type: actions.FETCH_LEAD_LOGS,
          id: id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_SIGNED_PROPOSAL_FILE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_SIGNED_PROPOSAL_FILE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_SIGNED_PROPOSAL_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadNurturingExemptionFile() {
  yield takeEvery('DOWNLOAD_NURTURING_EXEMPTION_FILE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.DOWNLOADING_NURTURING_EXEMPTION_FILE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadNurturingExemptionFileAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_NURTURING_EXEMPTION_FILE_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_NURTURING_EXEMPTION_FILE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_NURTURING_EXEMPTION_FILE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_NURTURING_EXEMPTION_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadSignedPSAFile() {
  yield takeEvery('DOWNLOAD_SIGNED_PSA_FILE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.DOWNLOADING_SIGNED_PSA_FILE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadSignedPSAFileAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_SIGNED_PSA_FILE_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }

        yield put({
          type: actions.FETCH_LEAD_LOGS,
          id: id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_SIGNED_PSA_FILE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_SIGNED_PSA_FILE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_SIGNED_PSA_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* getS3UrlsVatExemption() {
  yield takeEvery('STORE_VAT_EXEMPTION_FOR_UPLOAD', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_VAT_EXEMPTION_FOR_UPLOAD,
        loading: true
      });
      const state = yield select();
      const presignedUrlsVatExemption = state.AccountOfficer.presignedUrlsVatExemption;

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getURLsForLeadFilesAPI(key, files, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (presignedUrlsVatExemption && presignedUrlsVatExemption.length > 0) {
          urlsArr.push(...presignedUrlsVatExemption);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_VAT_EXEMPTION_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_VAT_EXEMPTION_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_VAT_EXEMPTION_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* downloadVatExemptionFile() {
  yield takeEvery('DOWNLOAD_VAT_EXEMPTION_FILE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.DOWNLOADING_VAT_EXEMPTION_FILE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadVatExemptionFileAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_VAT_EXEMPTION_FILE_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }

        yield put({
          type: actions.FETCH_LEAD_LOGS,
          id: id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_VAT_EXEMPTION_FILE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_VAT_EXEMPTION_FILE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_VAT_EXEMPTION_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* getS3UrlsWiredTransaction() {
  yield takeEvery('STORE_WIRED_TRANSACTION_FOR_UPLOAD', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_WIRED_TRANSACTION_FOR_UPLOAD,
        loading: true
      });
      const state = yield select();
      const presignedUrlsWiredTransaction = state.AccountOfficer.presignedUrlsWiredTransaction;

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getURLsForLeadFilesAPI(key, files, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (presignedUrlsWiredTransaction && presignedUrlsWiredTransaction.length > 0) {
          urlsArr.push(...presignedUrlsWiredTransaction);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_WIRED_TRANSACTION_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_WIRED_TRANSACTION_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_WIRED_TRANSACTION_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* downloadWiredTransactionFile() {
  yield takeEvery('DOWNLOAD_WIRED_TRANSACTION_FILE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.DOWNLOADING_WIRED_TRANSACTION_FILE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadWiredTransactionFileAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_WIRED_TRANSACTION_FILE_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }

        yield put({
          type: actions.FETCH_LEAD_LOGS,
          id: id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_WIRED_TRANSACTION_FILE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_WIRED_TRANSACTION_FILE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_WIRED_TRANSACTION_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllTemplateLead() {
  yield takeEvery('FETCH_TEMPLATE_LEAD_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_TEMPLATE_LEAD_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllTemplateLeadAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_TEMPLATE_LEAD_DATA_SUCCESS,
          loading: false,
          result: result && result.data && result.data.template_arr ? result.data.template_arr : [],
          fields: result && result.data && result.data.field_arr ? result.data.field_arr : []
        });
      } else {
        yield put({
          type: actions.FETCH_TEMPLATE_LEAD_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_TEMPLATE_LEAD_DATA_FAILED,
        loading: false
      });
    }
  });
}

export function* addTemplateLead() {
  yield takeEvery('ADD_TEMPLATE_LEAD_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_TEMPLATE_LEAD_DATA,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addTemplateLeadAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_TEMPLATE_LEAD_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_TEMPLATE_LEAD_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_TEMPLATE_LEAD_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_TEMPLATE_LEAD_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_TEMPLATE_LEAD_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editTemplateLead() {
  yield takeEvery('EDIT_TEMPLATE_LEAD_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_TEMPLATE_LEAD_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editTemplateLeadAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_TEMPLATE_LEAD_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_TEMPLATE_LEAD_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_TEMPLATE_LEAD_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_TEMPLATE_LEAD_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_TEMPLATE_LEAD_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadLeadTemplateFile() {
  yield takeEvery('DOWNLOAD_LEAD_TEMPLATE_FILE', function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_LEAD_TEMPLATE_FILE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadLeadTemplateFileAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_LEAD_TEMPLATE_FILE_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
          // window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_LEAD_TEMPLATE_FILE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_LEAD_TEMPLATE_FILE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_LEAD_TEMPLATE_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}


async function uploadFileToS3(url, payload) {
  return await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': payload.file.type
    },
    body: payload.file
  });
}

function requestVatReversalSalesAPI(data, roleAuth) {
  return post(`finance-operations/request-vat-exempt-reversal`, data, null, roleAuth);
}
function fetchReversalRequestByIDSalesAPI(id, roleAuth) {
  return get(`get-by-id/reversal-request/${id}`, null, null, null, null, roleAuth);
}
function fetchAllAccountOfficerAPI(roleAuth) {
  return get(`get-all/account-officer`, null, null, null, null, roleAuth);
}
function fetchAllAccountOfficerTeamAPI(roleAuth) {
  return get(`get-all/account-officer-team`, null, null, null, null, roleAuth);
}
function addAccountOfficerDataAPI(data, roleAuth) {
  return post(`add/account-officer`, data, null, null, roleAuth);
}
function fetchMerchantStatusCountAPI(data, roleAuth) {
  return post(`get-count/merchant-status`, data, null, null, roleAuth);
}
function addAccountOfficerTeamAPI(data, roleAuth) {
  return post(`add/account-officer-team`, data, null, null, roleAuth);
}
function passStatusRequirementDataAPI(data, id, roleAuth) {
  return post(`add/validation-requirement/${id}`, data, null, null, roleAuth);
}
function editAccountOfficerDataAPI(data, id, roleAuth) {
  return PUT(`edit/account-officer/${id}`, data, null, roleAuth);
}
function editAccountOfficerDataTeamAPI(data, id, roleAuth) {
  return PUT(`edit/account-officer-team/${id}`, data, null, roleAuth);
}
function updateAccountOfficerStatusAPI(data, id, roleAuth) {
  return PUT(`edit/account-officer/status/${id}`, data, null, roleAuth);
}
function deleteAccountOfficerDataAPI(id, roleAuth) {
  return DELETE(`delete/account-officer/${id}`, null, null, roleAuth);
}
function deleteAccountOfficerOnTeamAPI(data, id, roleAuth) {
  return PUT(`delete/account-officer-team/${id}`, data, null, roleAuth);
}

// Currently not used in Ui or part of old remodeled feature
function fetchAllLeadManagementListAPI(data, pagination, roleAuth) {
  return post(
    `get-all/merchant-leads`,
    data,
    pagination ? pagination : { page: 1, limit: 50 },
    null,
    roleAuth
  );
}

// Currently not used in Ui or part of old remodeled feature
function fetchFilteredLeadMerchantAPI(data, pagination, roleAuth) {
  return post(
    `get-all-filtered/merchant-leads`,
    data,
    pagination ? pagination : { page: 1, limit: 50 },
    null,
    roleAuth
  );
}
function fetchAllMerchantAPI(roleAuth) {
  return get(`get-all/lead-merchant`, null, null, null, null, roleAuth);
}
function fetchAllLeadManagementCalendarAPI(data, roleAuth) {
  return post(`get-all/appointment`, data, null, null, roleAuth);
}
function checkRequirmentStatusDataAPI(data, id, roleAuth) {
  return post(`check/validation-requirement/${id}`, data, null, null, roleAuth);
}
function fetchAllLeadManagementReportAPI(roleAuth) {
  return get(`get-all/lead-management-report`, null, null, null, null, roleAuth);
}
function updateLeadMerchantStatusListDataAPI(data, id, roleAuth) {
  return PUT(`edit-status/merchant-leads/${id}`, data, null, roleAuth);
}
function addHuntingLeadAPI(data, roleAuth) {
  return post(`add/hunting/leads`, data, null, null, roleAuth);
}
function addLeadsFromSuspectedDuplicatedsAPI(data, roleAuth) {
  return post(`add/hunting/leads-from-duplicates`, data, null, null, roleAuth);
}
function rejectLeadsFromSuspectedDuplicatedsAPI(data, roleAuth) {
  return post(`reject/hunting/leads-from-duplicates`, data, null, null, roleAuth);
}
function addLeadsByRMAPI(data, roleAuth) {
  return post(`add/hunting/leads-by-rm`, data, null, null, roleAuth);
}
function fetchAllLeadsAPI(payload, roleAuth) {
  return post(`get-all/leads`, payload, null, null, roleAuth);
}
function fetchAllUploadedLeadsFileDataAPI(data, roleAuth) {
  return post(`get-all/uploaded-leads`, data, null, null, roleAuth);
}
function fetchAllSuspectedDuplicateLeadsAPI(data, roleAuth) {
  return post(`get-all/suspected-duplicated-leads`, data, null, null, roleAuth);
}
function fetchLeadsByIDAPI(id, roleAuth) {
  return get(`get-by-id/leads/${id}`, null, null, null, null, roleAuth);
}
function fetchLeadSanitationByIDAPI(id, roleAuth) {
  return get(`get-by-id/lead-sanitation/${id}`, null, null, null, null, roleAuth);
}
function editLeadProfileAPI(data, id, roleAuth) {
  return PUT(`edit/lead-profile/${id}`, data, null, roleAuth);
}
function approveLeadSanitationAPI(data, id, roleAuth) {
  return PUT(`approve/lead-sanitation/${id}`, data, null, roleAuth);
}
function rejectLeadSanitationAPI(data, id, roleAuth) {
  return PUT(`reject/lead-sanitation/${id}`, data, null, roleAuth);
}
function editLeadSanitationProfileAPI(data, id, roleAuth) {
  return PUT(`edit/lead-sanitation-profile/${id}`, data, null, roleAuth);
}
function addLeadMerchantDataAPI(data, roleAuth) {
  return post(`add/merchant-leads`, data, null, null, roleAuth);
}
function addFarmingLeadMerchantDataAPI(data, roleAuth) {
  return post(`add/farming/merchant-leads`, data, null, null, roleAuth);
}
function addAppointmentDataAPI(data, roleAuth) {
  return post(`add/appointment`, data, null, null, roleAuth);
}
function fetchTargetProjectionsAPI(data, roleAuth) {
  return post(`get-all/target_projection`, data, null, null, roleAuth);
}
function fetchTargetProjectionsByTeamAPI(roleAuth) {
  return post(`get-team/target_projection`, null, null, null, null, roleAuth);
}
function addMonthlyTargetAPI(data, roleAuth) {
  return post(`add/monthly_target/target_projection`, data, null, null, roleAuth);
}
function addCustomerVisitAPI(data, roleAuth) {
  return post(`add/customer_visit/target_projection`, data, null, null, roleAuth);
}
function editAppointmentDataAPI(data, id, roleAuth) {
  return PUT(`edit-status/appointment/${id}`, data, null, roleAuth);
}
function updateMonthlyTargetAPI(data, id, roleAuth) {
  return PUT(`update/monthly-target/${id}`, data, null, roleAuth);
}
function updateCustomerVisitAPI(data, id, roleAuth) {
  return PUT(`update/customer-visit/${id}`, data, null, roleAuth);
}
function completeMerchantDetailAPI(data, id, roleAuth) {
  return post(`lead-to-merchant/merchant/${id}`, data, null, null, roleAuth);
}
function completeFarmingMerchantDetailAPI(data, id, roleAuth) {
  return post(`farming-to-merchant/merchant/${id}`, data, null, null, roleAuth);
}
function downloadRequirementFileDataAPI(data, roleAuth) {
  return post(`download/validation-requirement`, data, null, null, roleAuth);
}
function fetchMerchantServicesAPI(roleAuth) {
  return get(`merchant-services`, null, null, null, null, roleAuth);
}
function fetchInstallmentBankConfigurationsAPI(roleAuth) {
  return get(`installment-bank-configurations`, null, null, null, null, roleAuth);
}
function fetchMerchantStatusAPI(roleAuth) {
  return get(`get-all/merchant-status`, null, null, null, null, roleAuth);
}
function addMerchantStatusAPI(data, roleAuth) {
  return post(`add/merchant-status`, data, null, null, roleAuth);
}
function editMerchantStatusAPI(data, id, roleAuth) {
  return PUT(`edit/merchant-status/${id}`, data, null, roleAuth);
}
function editMerchantStatusNotificationSettingsAPI(data, id, roleAuth) {
  return PUT(`edit/merchant-status/notification-settings/${id}`, data, null, roleAuth);
}
function reorderMerchantStatusDataAPI(data, roleAuth) {
  return PUT(`reorder/merchant-status`, data, null, null, roleAuth);
}
function fetchLeadMonitoringAPI(payload, roleAuth) {
  return post(`get-all/lead-monitoring`, payload, null, null, roleAuth);
}
function fetchAllLeadSanitationAPI(data, roleAuth) {
  return post(`fetch/lead-sanitation`, data, null, null, roleAuth);
}
function getURLsForExemptionFilesAPI(key, data, roleAuth) {
  return post(`get/utility/multiple-presigned-s3-url-with-key/${key}`, data, null, null, roleAuth);
}
function manageExemptionFilesAPI(data, id, roleAuth) {
  return PUT(`lead-nurturing/exemption-files/${id}`, data, null, roleAuth);
}
function fetchAllLeadsNurturingAPI(data, roleAuth) {
  return post(`fetch/leads-nurturing`, data, null, null, roleAuth);
}
function fetchLeadNurturingByIDAPI(id, roleAuth) {
  return get(`get-by-id/leads-nurturing/${id}`, null, null, null, null, roleAuth);
}
function fetchLeadNurturingRequestByIDAPI(id, roleAuth) {
  return get(`get-by-id/leads-nurturing-exemption-request/${id}`, null, null, null, null, roleAuth);
}
function updateLeadNurturingAPI(data, id, roleAuth) {
  return PUT(`update/leads-nurturing/${id}`, data, null, roleAuth);
}
function triggerLeadNurturingExemptionRequestAPI(data, id, roleAuth) {
  return post(`lead-nurturing/exemption/requests/${id}`, data, null, roleAuth);
}
function addIntegrationFormRequestAPI(data, roleAuth) {
  return post(`integration-form-requests`, data, null, roleAuth);
}
function getURLsForLeadFilesAPI(key, data, roleAuth) {
  return post(`get/utility/multiple-presigned-s3-url-with-key/${key}`, data, null, null, roleAuth);
}
function sendLeadDiscussionAPI(data, roleAuth) {
  return post(`send/lead-discussion`, data, null, null, roleAuth);
}
function likeLeadDiscussionAPI(id, data, roleAuth) {
  return PUT(`like/lead-discussion/${id}`, data, null, roleAuth);
}
function fetchLeadDiscussionAPI(data, roleAuth) {
  return post(`fetch/lead-discussion`, data, null, null, roleAuth);
}
function downloadLeadAttachmentAPI(id, roleAuth) {
  return get(`download-lead-attachment-file/${id}`, null, null, null, null, roleAuth);
}
function downloadLeadChangeStatusAttachmentAPI(id, roleAuth) {
  return get(`download-lead-change-status-attachment-file/${id}`, null, null, null, null, roleAuth);
}
function downloadLeadActivityAttachmentAPI(id, roleAuth) {
  return get(`download-lead-activity-attachment-file/${id}`, null, null, null, null, roleAuth);
}
function fetchRelationsManagerActivityAPI(payload, roleAuth) {
  return post(`get-all/relations-manager-lead-logs`, payload, null, null, null, roleAuth);
}

function fetchAllMerchantManagementAPI(data, roleAuth) {
  return post(`fetch/merchant-management`, data, null, null, roleAuth);
}
function fetchMerchantManagementByIDAPI(id, roleAuth) {
  return get(`get-by-id/merchant-management/${id}`, null, null, null, null, roleAuth);
}
function fetchMISDataByIDAPI(id, roleAuth) {
  return get(`get-by-id/mis-data/${id}`, null, null, null, null, roleAuth);
}
function completeSalesReqInfoAPI(data, id, roleAuth) {
  return PUT(`complete-req/sales_req_info/${id}`, data, null, roleAuth);
}
function triggerInvoiceAPI(data, id, roleAuth) {
  return PUT(`trigger-invoice/sales_req_info/${id}`, data, null, roleAuth);
}
function sendMISFormLinkAPI(data, roleAuth) {
  return post(`merchant_mgmt/send_mis_link`, data, null, null, roleAuth);
}
function resendMISLinkAPI(data, roleAuth) {
  return post(`mis_links/resend`, data, null, null, roleAuth);
}
function downloadNurturingExemptionFileAPI(id, roleAuth) {
  return get(`download/lead-nurturing/${id}`, null, null, null, null, roleAuth);
}
function downloadSignedProposalFileAPI(id, roleAuth) {
  return get(`download-signed-proposal-file/${id}`, null, null, null, null, roleAuth);
}
function downloadSignedPSAFileAPI(id, roleAuth) {
  return get(`download-signed-psa-file/${id}`, null, null, null, null, roleAuth);
}
function downloadVatExemptionFileAPI(id, roleAuth) {
  return get(`download-vat-exemption-file/${id}`, null, null, null, null, roleAuth);
}
function downloadWiredTransactionFileAPI(id, roleAuth) {
  return get(`download-wired-transaction-file/${id}`, null, null, null, null, roleAuth);
}
function fetchAllTemplateLeadAPI(roleAuth) {
  return post(`get-all/template-lead`, null, null, null, roleAuth);
}
function addTemplateLeadAPI(data, roleAuth) {
  return post(`add/template-lead`, data, null, null, roleAuth);
}
function editTemplateLeadAPI(data, id, roleAuth) {
  return PUT(`edit/template-lead/${id}`, data, null, roleAuth);
}
function downloadLeadTemplateFileAPI(id, roleAuth) {
  return get(`download-lead-template/${id}`, null, null, null, null, roleAuth);
}

function* getRoleHeader() {
  const state = yield select();
  const identity = state.Auth.identity;
  const currentPage = state.App.currentPage;
  const currentAction = state.App.currentAction;
  if (currentAction) {
    return `${identity.role_id}:${currentPage.id}:${currentAction.id}`;
  } else {
    return `${identity.role_id}:${currentPage.id}`;
  }
}
function fetchLeadLogsAPI(id, pagination, roleAuth) {
  return get(
    `get/lead-logs/${id}`,
    pagination,
    null,
    null,
    null,
    roleAuth
  );
}
function changeStatusNurturingAPI(id, roleAuth) {
  return PUT(`change/status-nurturing/${id}`, null, null, roleAuth);
}
export default function* rootSaga() {
  yield all([
    fork(fetchAllAccountOfficers),
    fork(fetchAllAccountOfficerTeam),
    fork(addAccountOfficerData),
    fork(addAccountOfficerDataTeam),
    fork(editAccountOfficerData),
    fork(editAccountOfficerTeam),
    fork(deleteAccountOfficerData),
    fork(deleteAccountOfficerOnTeam),
    fork(updateAccountOfficerStatus),
    fork(fetchFilteredMerchantDataList),
    fork(fetchAllLeadManagementDataListByMQTT),
    fork(fetchAllLeadManagementDataList),
    fork(fetchAllLeadManagementDataCalendar),
    fork(fetchAllLeadManagementDataReport),
    fork(editLeadMerchantListStatusData),
    fork(addLeadMerchantData),
    fork(addFarmingLeadMerchantData),
    fork(fetchAllMerchantDataList),
    fork(addAppointmentData),
    fork(fetchTargetProjectionsData),
    fork(addMonthlyTargetData),
    fork(addCustomerVisitData),
    fork(editAppointmentData),
    fork(updateMonthlyTargetData),
    fork(updateCustomerVisitData),
    fork(completionOfMerchantDetails),
    fork(completionOfFarmingMerchantDetails),
    fork(fetchTargetProjectionsDataByTeam),
    fork(passStatusRequirementData),
    fork(fetchRequirementByMerchantID),
    fork(fetchStoryByMerchantIDData),
    fork(checkRequirmentStatusData),
    fork(downloadRequirementFileData),
    fork(requestVatExemptReversalSales),
    fork(fetchReversalRequestByIDSales),
    fork(addLeads),
    fork(fetchAllLeads),
    fork(fetchAllUploadedLeadsFileData),
    fork(fetchAllSuspectedDuplicateLeads),
    fork(fetchLeadsByID),
    fork(fetchMerchantStatusCount),
    fork(editLeads),
    fork(editLeadSanitation),
    fork(fetchMerchantServices),
    fork(fetchInstallmentBankConfigurations),
    fork(addIntegrationFormRequest),
    fork(fetchMerchantStatus),
    fork(addMerchantStatus),
    fork(editMerchantStatus),
    fork(changeMerchantStatus),
    fork(reorderMerchantStatusData),
    fork(editMerchantStatusNotificationSettings),
    fork(fetchLeadMonitoring),
    fork(fetchLeadLogs),
    fork(changeStatusNurturing),
    fork(getS3UrlsExemptionFiles),
    fork(manageExemptionFiles),
    fork(fetchLeadNurturingRequestByID),
    fork(downloadNurturingExemptionFile),
    fork(fetchAllLeadsNurturing),
    fork(fetchLeadNurturingByID),
    fork(updateLeadNurturing),
    fork(triggerLeadNurturingExemptionRequest),
    fork(getURLSforUploadedLeadFiles),
    fork(sendLeadDiscussion),
    fork(likeLeadDiscussion),
    fork(fetchLeadDiscussions),
    fork(downloadLeadAttachment),
    fork(getURLSforUploadedLeadChangeStatusFiles),
    fork(downloadLeadChangeStatusAttachment),
    fork(getURLSforUploadedLeadActivityFiles),
    fork(downloadLeadActivityAttachment),
    fork(addLeadsByRM),
    fork(addLeadsFromSuspectedDuplicates),
    fork(rejectLeadsFromSuspectedDuplicates),
    fork(fetchAllLeadSanitation),
    fork(fetchLeadSanitationByID),
    fork(approveLeadSanitation),
    fork(rejectLeadSanitation),
    fork(approveLeadSanitationLeadsManagement),
    fork(rejectLeadSanitationLeadsManagement),
    fork(fetchRelationsManagerActivity),
    fork(fetchAllMerchantManagement),
    fork(fetchMerchantManagementByID),
    fork(completeSalesReqInfo),
    fork(getS3UrlsSignedProposal),
    fork(getS3UrlsSignedPSA),
    fork(getS3UrlsVatExemption),
    fork(downloadSignedProposalFile),
    fork(downloadSignedPSAFile),
    fork(downloadVatExemptionFile),
    fork(triggerInvoice),
    fork(fetchAllTemplateLead),
    fork(addTemplateLead),
    fork(editTemplateLead),
    fork(getS3UrlsWiredTransaction),
    fork(downloadWiredTransactionFile),
    fork(sendMISFormLink),
    fork(fetchMISDataByID),
    fork(downloadLeadTemplateFile),
    fork(resendMISLink)
  ]);
}
